import { parse as JSXRenderFunction } from '@saasquatch/stencil-html-parser';

/**
 * JSXRender
 * @param html
 * @constructor
 */
export const JSXRender = (html) => {
  return JSXRenderFunction(html);
};
